import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GLOBAL } from 'src/app/services/global';
import { Busqueda_dirComponent } from '../../totem/busqueda_dir/busqueda_dir.component';

@Component({
    selector: "page-auxTotem",
    templateUrl: "auxTotem.component.html",
    styleUrls: ["./auxTotem.component.css"]
})

export class AuxTotemComponent{
  
  public nombreMuni = GLOBAL.nombreMuni;
  public filedomSolicitudUrl = GLOBAL.filedomSolicitudUrl;
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
  public seguimientoCertificados = GLOBAL.seguimientoCertificados;
    constructor(private dialog: MatDialog, private _router:Router ){
  }


  totem_busqueda (){
    this.dialog.closeAll();    
    this._router.navigate([`/busqueda-direccion`]);
    //this.dialog.open(Busqueda_dirComponent);
  }

  sign(tipo){
    //  alert(tipo);
    if(sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")){
      this.dialog.closeAll();
      if (tipo=='busqueda_dir'){
        this._router.navigate([`/busqueda-direccion`]);
        this.dialog.open(Busqueda_dirComponent);
      }
      /* else if (tipo=='seguimiento_expediente'){

      }else if (tipo=='seguimiento_correspondencia'){
        this._router.navigate([`/seguimiento_correspondencia`]);
      }
      else if (tipo=='seguimiento_fotocopia'){
        this._router.navigate([`/seguimiento_fotocopia`]);
      } */
    } else {
      if (tipo=='busqueda_dir'){
        //console.log("expediente 2");
        this._router.navigate([`/busqueda-direccion`]);
        this.dialog.open(Busqueda_dirComponent);
      }
      /* else if (tipo=='seguimiento_expediente'){
        localStorage.setItem("navdomcloud", 'seguimiento_expediente')
      }
      else if (tipo=='seguimiento_correspondencia'){
        this._router.navigate([`/seguimiento_correspondencia`]);
      }
      else if (tipo=='seguimiento_fotocopia'){
        this._router.navigate([`/seguimiento_fotocopia`]);
      } */
    }
    this.dialog.closeAll()
  }


}
